import { AccountingMigrationsColumn } from "@common/types/views/accountingMigrationsView";
import { ViewConfig } from "@lib/views";
import { ViewDensity } from "@common/types/views/views";
import { EntityCell } from "./Cells/EntityCell";
import { SourceCell } from "./Cells/SourceCell";
import { StartDateCell } from "./Cells/StartDateCell";
import { EndDateCell } from "./Cells/EndDateCell";
import { StatusCell } from "./Cells/StatusCell";
import { ActionsCell } from "./Cells/ActionsCell";
import { AccountingMigrationRow } from "./utils";

export const createAccountingMigrationsViewConfig = (): ViewConfig<
    AccountingMigrationRow,
    AccountingMigrationsColumn,
    never
> => ({
    columns: {
        [AccountingMigrationsColumn.ENTITY]: {
            accessorKey: "entity.name",
            name: "Entity",
            header: "Entity",
            immutable: true,
            cell: EntityCell,
            minSize: 200,
            maxSize: 600,
        },
        [AccountingMigrationsColumn.SOURCE]: {
            accessorKey: "accountingMigration.externalSystem",
            name: "Source",
            header: "Source",
            cell: SourceCell,
            minSize: 160,
            maxSize: 240,
        },
        [AccountingMigrationsColumn.START_DATE]: {
            accessorKey: "accountingMigration.startDate",
            name: "Start date",
            header: "Start date",
            cell: StartDateCell,
            minSize: 110,
            maxSize: 150,
        },
        [AccountingMigrationsColumn.END_DATE]: {
            accessorKey: "entity.bookkeepingStartDate",
            name: "End date",
            header: "End date",
            cell: EndDateCell,
            minSize: 110,
            maxSize: 150,
        },
        [AccountingMigrationsColumn.STATUS]: {
            accessorKey: "status",
            name: "Status",
            header: "Status",
            cell: StatusCell,
            minSize: 120,
            maxSize: 180,
        },
        [AccountingMigrationsColumn.ACTIONS]: {
            accessorKey: "entity.id",
            name: "Actions",
            header: "",
            align: "right",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
            minSize: 100,
            maxSize: 100,
        },
    },
    density: ViewDensity.LG,
});
